import { BookingInfoFormScheme } from "../../../components/Forms/BookingInfoForm/validation.ts";
import { EquipmentFormScheme } from "../../../components/Forms/EquipmentForm/validation.ts";
import { createContext, FC, ReactNode, useContext, useState } from "react";

type BookingContextValues = {
  booking: BookingInfoFormScheme | null;
  equipment: EquipmentFormScheme | null;
  setBooking: (booking: BookingInfoFormScheme | null) => void;
  setEquipment: (equipment: EquipmentFormScheme | null) => void;
}

const noop = () => {};

const BookingContext = createContext<BookingContextValues>({
  booking: null,
  equipment: null,
  setBooking: noop,
  setEquipment: noop
});

type BookingProviderProps = {
  children: ReactNode;
};

export const BookingProvider:FC<BookingProviderProps> = ({ children }) => {
  const [booking, setBooking] = useState<BookingInfoFormScheme | null>(null);
  const [equipment, setEquipment] = useState<EquipmentFormScheme | null>(null);


  return <BookingContext.Provider
    value={{
      booking,
      equipment,
      setEquipment,
      setBooking,
    }}
  >
    {children}
  </BookingContext.Provider>;
};

export const useBooking = () => {
  const bookingContext = useContext(BookingContext);

  if (!bookingContext) {
    throw new Error("useBooking was used outside of its Provider");
  }

  return bookingContext;
};
